import { createHttpService } from '../../../http-service/http-service-factory';
import { SSOHttpServiceConfigurator } from '../../sso-http-service-configurator';
import { B2C_BASE_URL } from './const';

export const B2CHttpService = createHttpService(
  new SSOHttpServiceConfigurator(B2C_BASE_URL)
);